
(function() {
    if (window.recommendationsModuleInitialized) {
        return;
    }
    window.recommendationsModuleInitialized = true;

    // --- ELEMENTS AND VARIABLES ---
    
    const listElement = document.getElementById('list-upsell-cart');
    const carouselSection = document.getElementById('recommendations-carousel');
    const loadingElement = document.getElementById('splide-loading');
    
    const MAX_PRODUCTS_TO_SHOW = 6;
    const API_LIMIT = 15; 
    let recommendationsLoaded = false; 

    if (!listElement || !carouselSection || !loadingElement) {
        console.error("CRITICAL ERROR: Upsell containers not found.");
        return;
    }

    // --- UTILITY FUNCTIONS ---

    const formatMoney = (priceInCents, currencyCode = 'USD') => {
        if (typeof priceInCents !== 'number') return '';
        const dollars = (priceInCents / 100).toFixed(2);
        return `${dollars} ${currencyCode}`;
    };

    /**
     * Handles dynamic AJAX add to cart and dispatches theme event for update.
     * @param {Event} event 
     */
    const handleAddToCart = (event) => {
        event.preventDefault();
        
        const form = event.currentTarget;
        const button = form.querySelector('button[type="submit"]');
        const formData = new FormData(form);
        
        button.disabled = true;
        button.querySelector('.push-btn__surface').textContent = 'Adding...';

        fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            body: formData,
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(response => response.json())
        .then(data => {
            if (data.status) {
                 // Handle error if Shopify returns a JSON error object
                console.error('AJAX Add to Cart Error:', data);
                alert(`Error adding item: ${data.message}`);
                button.querySelector('.push-btn__surface').textContent = 'Error';
            } else {
                // Dispatch event to update the cart drawer in the theme
                document.dispatchEvent(new CustomEvent('theme:update:cart'));
                button.querySelector('.push-btn__surface').textContent = 'Added!';
            }
        })
        .catch(error => {
            console.error('Network or Parse Error during Add to Cart:', error);
            button.querySelector('.push-btn__surface').textContent = 'Failed';
        })
        .finally(() => {
            setTimeout(() => {
                button.disabled = false;
                button.querySelector('.push-btn__surface').textContent = 'Add to Cart';
            }, 1000);
        });
    };

    const generateProductHtml = (product, currency) => {
        const currentVariant = product.variants[0]; 
        const variantId = currentVariant.id;
        const available = currentVariant.available;
        const onSale = product.compare_at_price_max > product.price;

        const priceHtml = `<span class="inline-block font-bold" data-product-price >$${formatMoney(currentVariant.price, currency)}</span>
            ${onSale ? `<span class="text-sm ml-2"><s data-compare-price class="data-wpd-hide text-scheme-text">$${formatMoney(product.compare_at_price_max, currency)}</s></span>` : ''}`;

        const liHtml = `
            <div class="product-tile product-tile-product relative text-scheme-text card recommendation-card">
                <div class="contents" data-product-root="ajax-${product.id}" data-variant-id="${variantId}">
                    <div class="product-tile__container bg-scheme-card card__surface w-full mx-auto">
                        
                        <a href="${product.url}" class="product-tile__featured-media group block">
                            <div class="product-media-object relative pb-media-shadow">
                                <img 
                                    src="${product.featured_image}" 
                                    alt="${product.title}" 
                                    loading="lazy"
                                    class="media__styled-element w-full h-auto object-cover"
                                    onerror="this.onerror=null; this.src='https://placehold.co/300x300/e0e0e0/555?text=No+Image'"
                                />
                            </div>
                        </a>
                        <div class="product-tile product-tile-content break-words text-center">
                            <a href="${product.url}" class="block w-full">
                                <h3 class="font-body text-base">${product.title}</h3>
                                <p class="text-sm text-scheme-text sku-text">SKU: ${currentVariant.sku || 'N/A'}</p>
                                <span data-wpd-product-handle="${ product.handle }" data-wpd-variant-id="${ variantId }" data-wpd-variant-price="${ product.price }" data-wpd-variant-compare-at-price="${ product.compare_at_price }" data-wpd-product-id="${ product.id }"> ${priceHtml} </span>
                            </a>
                            <form method="post" class="upsell-add-to-cart-form w-full" data-variant-id="${variantId}">
                                <input type="hidden" name="id" value="${variantId}">
                                <button type="submit" name="add" class="push-btn w-full" ${available ? '' : 'disabled'}>
                                    <span class="push-btn__surface">${available ? 'Add to Cart' : 'Sold Out'}</span>
                                </button>
                            </form>
                        </div>

                        
                        <div class="product-tile__quick-buy">
                        </div>
                        ${!available ? `<div class="absolute top-0 right-0 m-2"><span class="bg-scheme-text text-scheme-text-contrast text-xs px-2 py-1 rounded">SOLD OUT</span></div>` : ''}
                        ${available && onSale ? `<div class="absolute top-0 right-0 m-2"><span class="bg-scheme-accent-1 text-scheme-accent-1-contrast text-xs px-2 py-1 rounded">SALE</span></div>` : ''}
                    </div>
                </div>
            </div>
        `;
        
        const li = document.createElement('li');
        li.className = 'splide__slide';
        li.innerHTML = liHtml;
        return li;
    };

    const renderCarousel = (products, listElement, carouselSection, currency) => {
        while (listElement.firstChild) { listElement.removeChild(listElement.firstChild); }
        products.forEach(product => {
            const li = generateProductHtml(product, currency);
            listElement.appendChild(li);
        });

        if (listElement.children.length === 0) {
             loadingElement.textContent = "Could not insert content.";
             return;
        }

        if (typeof Splide !== 'undefined') {
            
            // 🌟 MODIFICATION: Set perPage to 2 for desktop/tablet, 1 for mobile
            const splideInstance = new Splide(carouselSection, {
                mediaQuery: 'min', 
                arrows: true, 
                pagination: false, 
                rewind: true, 
                gap: '10px',  
                type: 'loop', 
                perPage: 1, // <--- 2 per slide (default)
                perMove: 1, 
                padding: { left: '5px', right: '5px' },
                breakpoints: {
                    640: { perPage: 1, gap: '10px'}, // Mobile
                    990: { perPage: 1, gap: '10px' } // Tablet/Desktop
                }
            }).mount();
            // 🌟 END MODIFICATION 🌟

            // Add event listeners for dynamic cart actions AFTER rendering
            listElement.querySelectorAll('.upsell-add-to-cart-form').forEach(form => {
                form.addEventListener('submit', handleAddToCart);
            });

            setTimeout(() => {
                splideInstance.refresh();
                loadingElement.style.display = 'none';
                carouselSection.style.opacity = '1';
                carouselSection.style.height = 'auto';
                carouselSection.style.overflow = 'visible';
                console.log('VISUAL SUCCESS: Carousel visible and Splide refreshed.');
            }, 200); 

        } else {
            loadingElement.textContent = "Error: Splide library not loaded.";
            console.error("CRITICAL ERROR: SPLIDE is not defined.");
        }
    };

    // --- MAIN AJAX LOGIC ---

    const fetchAndRender = () => {
        if (recommendationsLoaded) { return; }

        fetch(window.Shopify.routes.root + 'cart.js')
            .then(response => response.json())
            .then(cart => {
                if (cart.item_count === 0) {
                    
                    return Promise.reject('Cart empty');
                }
                const cartProductIds = cart.items.map(item => item.product_id);
                const baseProductId = cartProductIds[0]; 
                if (!baseProductId) return Promise.reject('Base product ID not found.');

                const recommendationsUrl = `${window.Shopify.routes.root}recommendations/products.json?product_id=${baseProductId}&limit=${API_LIMIT}&intent=related`;
                return fetch(recommendationsUrl)
                    .then(response => response.json())
                    .then(data => ({ products: data.products, cartProductIds: cartProductIds, currency: cart.currency.iso_code }));
            })
            .then(({ products, cartProductIds, currency }) => {
                const filteredProducts = products.filter(product => !cartProductIds.includes(product.id)).slice(0, MAX_PRODUCTS_TO_SHOW); 

                if (filteredProducts.length > 0) {
                    renderCarousel(filteredProducts, listElement, carouselSection, currency);
                    recommendationsLoaded = true;
                } else {
                    loadingElement.textContent = "No unique recommendations found.";
                }
            })
            .catch(error => {
                if (error !== 'Cart empty' && error !== 'Base product ID not found.') {
                    console.error('AJAX/RENDER FAILURE:', error);
                    loadingElement.textContent = "There was an error loading recommendations.";
                }
            });
    };

    // --- THEME EVENT DISPATCHER ---

    // Using the confirmed theme open event to start loading
    document.addEventListener('theme:cart-drawer:open', fetchAndRender);
    
    // Fallback security check if the cart is already open on page load
    setTimeout(() => {
        const cartDrawerEl = document.querySelector('[data-cart-drawer]');
        if (cartDrawerEl && cartDrawerEl.getAttribute('aria-hidden') === 'false' && !recommendationsLoaded) {
            fetchAndRender();
        }
    }, 1000);

})();
